// import React, { useEffect, useState } from "react";
// import config from "../config";
// import PencilIcon from "../assets/icons/pencil_icon";
// import userImage from "../assets/icons/user.png";
// import { toast } from 'react-toastify';

// const AddCustomerFormModal = ({ isOpen, onClose, onCustomerCreated }) => {
//   const [customerData, setCustomerData] = useState({
//     customer_name: "",
//     mobile: "",
//     email: "",
//     address: "",
//     customer_type: "",
//   });

//   const [profilePicture, setProfilePicture] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCustomerData({ ...customerData, [name]: value });
//   };

//   const handleFileChange = (e) => {
//     setProfilePicture(e.target.files[0]);
//   };

//   const handleSave = async () => {
//     const { customer_name, email, mobile } = customerData;

//     if (!customer_name.trim() || !mobile.trim() || !email.trim()) {
//       toast.error("Name, Mobile, and Email are required.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append("customer_name", customer_name);
//       formData.append("mobile", mobile);
//       formData.append("email", email);
//       formData.append("address", customerData.address);
//       formData.append("customer_type", customerData.customer_type);

//       if (profilePicture) {
//         formData.append("profile_picture", profilePicture);
//       }

//       const response = await fetch(`${config.BASE_URL}/api/v1/add`, {
//         method: "POST",
//         body: formData,
//       });

//       const result = await response.json();

//       if (response.status === 201) {
//         toast.success("Customer added successfully!");
//         // Pass the new customer back to the parent modal
//         onCustomerCreated(result.customer); 
//         onClose();
//       } else {
//         toast.error(result.message || "Failed to add customer.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay" style={{ zIndex: 1100 }}>
//       <div className="modal-content">
//         <div className="popup_header">
//           <h4 >New Customer</h4>
//           <button type="button" onClick={onClose}>×</button>
//         </div>
//         <div className="form-container">
//           <div className="avatar-section">
//             <img
//               src={profilePicture ? URL.createObjectURL(profilePicture) : userImage}
//               alt="Avatar"
//               className="avatar"
//             />
//             <label className="edit-avatar-btn">
//               <PencilIcon />
//               <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />
//             </label>
//           </div>
//           <form className="customer-form" onSubmit={(e) => e.preventDefault()}>
//             <div className="form_field">
//               <label className="label-text">Customer Name*</label>
//               <input type="text" name="customer_name" value={customerData.customer_name} onChange={handleInputChange} />
//             </div>
//             <div className="form_field">
//               <label className="label-text">Mobile*</label>
//               <input type="tel" name="mobile" value={customerData.mobile} onChange={handleInputChange} />
//             </div>
//             <div className="form_field">
//               <label className="label-text">Email*</label>
//               <input type="email" name="email" value={customerData.email} onChange={handleInputChange} />
//             </div>
//             <div className="form_field">
//               <label className="label-text">Address</label>
//               <input type="text" name="address" value={customerData.address} onChange={handleInputChange} />
//             </div>
//             <div className="form_field">
//               <label className="label-text" >Customer Type</label>
//               <select name="customer_type" value={customerData.customer_type} onChange={handleInputChange}>
//                 <option value="">Select Type</option>
//                 <option value="Special Occasion">Special Occasion</option>
//                 <option value="Business">Business</option>
//               </select>
//             </div>
//             <div className="form_footer">
//               <button type="button" className="btn" onClick={handleSave} disabled={loading}>
//                 {loading ? "Saving..." : "Save Customer"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddCustomerFormModal;

// AddCustomerFormModal.js

import React, { useState } from "react";
import config from "../config";
import PencilIcon from "../assets/icons/pencil_icon";
import userImage from "../assets/icons/user.png";
import { toast } from 'react-toastify';

const AddCustomerFormModal = ({ isOpen, onClose, onCustomerCreated }) => {
  const [customerData, setCustomerData] = useState({
    customer_name: "",
    mobile: "",
    email: "",
    address: "",
    customer_type: "",
  });
  const [error,setError]=useState("")

  const [profilePicture, setProfilePicture] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData({ ...customerData, [name]: value });
  };

  const handleFileChange = (e) => {
    setProfilePicture(e.target.files[0]);
  };

  const handleSave = async () => {
    const { customer_name, email, mobile } = customerData;
    if (!customer_name.trim() || !mobile.trim() || !email.trim()) {
      toast.error("Name, Mobile, and Email are required.");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("customer_name", customer_name);
      formData.append("mobile", mobile);
      formData.append("email", email);
      formData.append("address", customerData.address);
      formData.append("customer_type", customerData.customer_type);

      if (profilePicture) {
        formData.append("profile_picture", profilePicture);
      }

      const response = await fetch(`${config.BASE_URL}/api/v1/add`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.status === 201) {
        toast.success("Customer added successfully!");
        setCustomerData({
        customer_name: "",
        mobile: "",
        email: "",
        address: "",
        customer_type: "",
      });
      setProfilePicture(null)
        onCustomerCreated(result.customer); 

        onClose();
      } else {
        toast.error(result.message || "Failed to add customer.");
        setError(result.message || "Failed to add customer.")
        setTimeout(() => {
        setError("");
      }, 3000);
      }
    } catch (error) {
      toast.error("Something went wrong.");
      setError("Something went wrong.")
       setTimeout(() => {
        setError("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-container">
        <div className="custom-modal-header">
          <h3>New Customer</h3>
          <button className="close-x-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="custom-modal-body">
          <div className="profile-upload-section">
            <div className="profile-preview">
              <img
                src={profilePicture ? URL.createObjectURL(profilePicture) : userImage}
                alt="Profile"
              />
              <label className="profile-edit-badge">
                <PencilIcon />
                <input type="file" accept="image/*" onChange={handleFileChange} />
              </label>
            </div>
          </div>

          <form className="customer-entry-form" onSubmit={(e) => e.preventDefault()}>
            <div className="input-row">
              <div className="input-wrapper">
                <label>Customer Name*</label>
                <input 
                  type="text" 
                  name="customer_name" 
                  // placeholder="Enter full name"
                  value={customerData.customer_name} 
                  onChange={handleInputChange} 
                />
              </div>
              <div className="input-wrapper">
                <label>Mobile*</label>
                <input 
                  type="tel" 
                  name="mobile" 
                  value={customerData.mobile} 
                  onChange={handleInputChange} 
                />
              </div>
            </div>

            <div className="input-wrapper">
              <label>Email*</label>
              <input 
                type="email" 
                name="email" 
                value={customerData.email} 
                onChange={handleInputChange} 
              />
            </div>

            <div className="input-wrapper">
              <label>Address</label>
              <input 
                type="text" 
                name="address" 
                value={customerData.address} 
                onChange={handleInputChange} 
              />
            </div>

            <div className="input-wrapper">
              <label>Customer Type</label>
              <select name="customer_type" value={customerData.customer_type} onChange={handleInputChange}>
                <option value="">Select Type</option>
                <option value="Special Occasion">Special Occasion</option>
                <option value="Business">Business</option>
              </select>
            </div>
            {error && <div className="error-box">
                {error}</div>}
            <div className="custom-modal-footer">
              <button type="button" className="cancel-action-btn" onClick={onClose}>Cancel</button>
              <button type="button" className="save-action-btn" onClick={handleSave} disabled={loading}>
                {loading ? "Saving..." : "Save Customer"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerFormModal;